// Picture of a source: the copy in our store (int_thumbnail_url = /api/sources/{id}/avatar?v=...,
// core avatar_store) first, then the base64 that coredb still holds, else nothing.
export const STORE_PREFIX = '/api/sources/';

export function isStoredAvatar(url) {
  return typeof url === 'string' && url.startsWith(STORE_PREFIX);
}

export function base64Src(encoded) {
  if (!encoded) return '';
  return encoded.startsWith('data:') ? encoded : `data:image/jpeg;base64,${encoded}`;
}

export function avatarSrc(item) {
  if (!item) return '';
  if (isStoredAvatar(item.int_thumbnail_url)) return item.int_thumbnail_url;
  return base64Src(item.thumbnail_encoded);
}
